import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Card from 'assets/components/card/Card';
import ThemeCardComment from 'assets/components/card/themes/Theme.Card.Comment';
import Collection from 'assets/components/data/Collection';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import Sanitizer from 'assets/components/textBox/Sanitizer';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { orderBy } from 'lodash';
import { useContractComments } from '../../Sales.Contract.Hooks';

const ContractInfoNotes = () => {
  const { lang } = getLocales();
  const {
    isLoadingComments,
    comments,
    deleteApi,
    form,
    action,
    setAction,
    canDeleteComments,
    canEditComments,
    commentsApi,
  } = useContractComments();

  return !commentsApi.payload?.data ? (
    <ErrorWrapper children={lang.noInfo} />
  ) : (
    <div
      style={{
        marginLeft: Theme.Size.XL,
        marginRight: Theme.Size.XL,
      }}
    >
      <h2>{lang.notes}</h2>
      {action === 'delete' && (
        <Confirm
          data={form.data}
          onConfirm={({ id }) => deleteApi.execute({ id })}
          onClose={() => {
            setAction(null);
            form.update({});
          }}
          actionName={lang.delete}
          itemName={lang.comment}
          confirmationType="nextButton"
          subcomponents={ThemeConfirmDefault}
        />
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: Theme.Size.M,
        }}
      >
        <Collection
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: Theme.Size.S,
          }}
          data={orderBy(comments || [], (it) => it.createdAtUtcUnix, ['asc'])}
          map={({ data: comment }) => (
            <Card
              info={comment.displayInfo.info}
              title={comment.displayInfo.title}
              subtitle={<Sanitizer text={comment.displayInfo.subtitle} />}
              media={comment.displayInfo.media}
              class={ThemeCardComment}
              description={
                !(action === 'edit' && form.data.id === comment.id) ? null : (
                  <div
                    style={{
                      maxWidth: `calc(365px - ${Theme.Size.M})`,
                    }}
                  >
                    <MultilineTextInput name="comment" value={form.data.comment} onChange={form.update} />
                  </div>
                )
              }
              actions={
                <>
                  <div
                    style={{
                      marginRight: 'auto',
                      alignSelf: 'center',
                      fontSize: Theme.FontSize.S,
                    }}
                  >
                    {comment.createdAtUtcUnix < comment.modifiedAtUtcUnix && <>&nbsp;({lang.edited})</>}
                  </div>
                  {action === 'edit' && form.data.id === comment.id ? (
                    <>
                      <Button
                        class={ThemeButtonCircle}
                        onClick={() => {
                          form.set({});
                          setAction(null);
                        }}
                        render={lang.cancel}
                      />
                      <Button
                        class={ThemeButtonCircle}
                        onClick={form.submit}
                        render={lang.save}
                        disabled={form.hasErrors || form.isSubmitted || !canEditComments}
                        active={!form.hasErrors || form.isSubmitted || !canEditComments}
                        isLoading={form.isSubmitted}
                      />
                    </>
                  ) : (
                    <>
                      <Button
                        class={ThemeButtonCircle}
                        onClick={() => {
                          setAction('edit');
                          form.set(comment);
                        }}
                        media="fas-edit"
                        disabled={!canEditComments}
                      />
                      <Button
                        class={ThemeButtonCircle}
                        onClick={() => {
                          setAction('delete');
                          form.set(comment);
                        }}
                        disabled={!canDeleteComments}
                        media="fas-trash"
                      />
                    </>
                  )}
                </>
              }
            />
          )}
        />
        {!action && !isLoadingComments && (
          <div>
            <MultilineTextInput name="comment" value={form.data.comment} onChange={form.update} />
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: Theme.Size.M }}>
              <Button
                class={ThemeButtonCircle}
                onClick={form.submit}
                render={lang.add}
                disabled={form.hasErrors || form.isSubmitted || !canEditComments}
                active={!form.hasErrors || !canEditComments}
                isLoading={form.isSubmitted}
                media="fas-paper-plane"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContractInfoNotes;
